exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#banner[data-v-9327ce6e]{width:96%;padding:2% 0;margin:0 auto}#banner ul[data-v-9327ce6e]{width:100%;overflow:hidden;padding:6% 0 4%}#banner>ul>li[data-v-9327ce6e]{float:left;width:25%}#banner>ul>li a[data-v-9327ce6e]{width:100%;display:block;text-align:center;padding:0 2%}#banner>ul>li a img[data-v-9327ce6e]{width:56%}#banner>ul>li a span[data-v-9327ce6e]{display:block;font-size:1.3rem;color:#333;padding:.5rem 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-9327ce6e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Banner.vue
// module id = 47
// module chunks = 0